
export const environment = {
    production: false,
    loginUrl: "https://prod-scmp.auth.us-east-1.amazoncognito.com/login?client_id=6jpjoklm113fuf1mbide5okfs7&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://portal.hunterstrategy.net/login",
    apiUrl: "https://opgtvq90m1.execute-api.us-east-1.amazonaws.com/dev/",
    };
